import PropTypes from "prop-types";

import { FLIGHT_CAR, FLIGHT_HOTEL, FLIGHT_HOTEL_CAR } from "../defines/packageType";

export const packageTypeProps = PropTypes.oneOf([FLIGHT_CAR, FLIGHT_HOTEL_CAR, FLIGHT_HOTEL]);
